import { createContext, useContext } from 'react';

export interface ShellShortcutsContextValue {
  openGlobalSearch: () => void;
  openShortcutsHelp: () => void;
}

const ShellShortcutsContext = createContext<ShellShortcutsContextValue | null>(null);

export function ShellShortcutsProvider({
  value,
  children,
}: {
  value: ShellShortcutsContextValue;
  children: React.ReactNode;
}) {
  return <ShellShortcutsContext.Provider value={value}>{children}</ShellShortcutsContext.Provider>;
}

export function useShellShortcuts(): ShellShortcutsContextValue {
  const ctx = useContext(ShellShortcutsContext);
  if (!ctx) {
    return {
      openGlobalSearch: () => {},
      openShortcutsHelp: () => {},
    };
  }
  return ctx;
}
